module.exports = __webpack_public_path__ + "assets/img/warrior-name-9101b867.png";